import styled from 'styled-components'
import Separator from '../Separator'

const Section = styled.div`
  padding: 12px 0 16px;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  /* Children should be Header, AttributeList or AttributeColumns */
  & > * {
    margin-left: ${({ theme }) => `${theme.space[5]}px`};
  }

  ${Separator} {
    margin-right: 0;
  }

  /* Inside a section, gives vertical spacing to children */
  & > * + * {
    margin-top: 12px;
  }
`

export default Section
